var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcClock = function SvgIcClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic_clock")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_clock",
    transform: "translate(-1.000000, 0.000000)",
    fill: "#697287",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.8,11.6 C4.45321321,11.6040462 2.3352556,10.1934898 1.43437415,8.02650176 C0.533492686,5.85951371 1.02724469,3.36319188 2.68524361,1.7023294 C4.34324254,0.041466917 6.83870862,-0.456592061 9.00724803,0.440548649 C11.1757874,1.33768936 12.5899965,3.45320972 12.59,5.8 C12.5845162,8.99707695 9.99706273,11.5889993 6.8,11.6 L6.8,11.6 Z M6.8,1 C4.85767634,0.995953484 3.10435542,2.16286687 2.35825478,3.95617985 C1.61215415,5.74949282 2.02034976,7.81569645 3.39235008,9.19056107 C4.76435039,10.5654257 6.82969823,10.9779295 8.62456331,10.2355704 C10.4194284,9.49321138 11.5899958,7.74232788 11.59,5.8 C11.5900057,3.15293354 9.44706072,1.00551472 6.8,1 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "8.62 8.33 6.3 6 6.3 1.84 7.3 1.84 7.3 5.59 9.33 7.62"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_clock.95cf6456.svg";
export { ForwardRef as ReactComponent };